import Tag from '../reusable/Tag';
import { USER_ROLES } from '../../constants';
import { getSurveyReportStatusDisplay } from '../survey-reports/SurveyReportStatus';
import { getFocusGroupReportStatusDisplay } from '../focus-groups/FocusGroupReportStatus';
import { getTranscriptSelectionStatusDisplay } from '../transcripts/TranscriptSelectionStatus';
import { getStudentVoiceStatusDisplay } from '../student-voice/StudentVoiceStatus';
import { getSchoolReportStatusDisplay } from '../school-reports/SchoolReportStatus';

interface CategoryStatus {
  surveyReport: string | null;
  focusGroupReport: string | null;
  transcriptSelection: string | null;
  studentVoice: string | null;
  schoolReport: string | null;
}

interface SchoolProgressTagProps {
  categoryStatuses: CategoryStatus;
  totalCategories: number;
  userRole?: string;
}

const SchoolProgressTag = ({ categoryStatuses, totalCategories, userRole }: SchoolProgressTagProps) => {
  const isFacilitator = userRole === USER_ROLES.FACILITATOR;

  const statuses = isFacilitator
    ? [
        getTranscriptSelectionStatusDisplay(categoryStatuses.transcriptSelection),
        getStudentVoiceStatusDisplay(categoryStatuses.studentVoice),
      ]
    : [
        getSurveyReportStatusDisplay(categoryStatuses.surveyReport),
        getFocusGroupReportStatusDisplay(categoryStatuses.focusGroupReport),
        getTranscriptSelectionStatusDisplay(categoryStatuses.transcriptSelection),
        getStudentVoiceStatusDisplay(categoryStatuses.studentVoice),
        getSchoolReportStatusDisplay(categoryStatuses.schoolReport, userRole),
      ];

  const categoriesInProgress = statuses.filter((status) => status.type === 'progress').length;
  const categoriesCompleted = statuses.filter((status) => status.type === 'completed').length;

  if (categoriesInProgress === 0 && categoriesCompleted === 0) {
    return <Tag type="pending" text="Not started" size="small" />;
  }

  if (categoriesInProgress === 0) {
    return null;
  }

  return (
    <Tag type="progress" text={`${categoriesInProgress}/${totalCategories} categories in progress`} size="small" />
  );
};

export default SchoolProgressTag;
